module.exports = __webpack_public_path__ + "first-5-watermark.jpg?0b2425c7129dbac373f3e2cff14bd8e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5-watermark.jpg
// module id = 523
// module chunks = 0